import type {
  AcademicRiskActionRepository,
  EndOfActionResponse,
} from '@/domains/academicRisk';

export class EndOfActionUseCase {
  private repository: AcademicRiskActionRepository;

  constructor(repository: AcademicRiskActionRepository) {
    this.repository = repository;
  }

  async execute(
    cod_incorporacion_accion: number,
  ): Promise<EndOfActionResponse> {
    return await this.repository.endOfAction(cod_incorporacion_accion);
  }
}
